import {Auction, Notification} from "../domain-models"
import React from "react"
import _ from "lodash"
import {store} from "../store"
import {hideAuction, showAuction, updateNotifications} from "../redux/actions"
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {make} from "../filters"
import {Link} from "react-router-dom"
import {connect} from "react-redux"
import {GlobalState} from "../state"
import {Http} from "../mixins/http"
import Form from "../mixins/form"
import ClickEvent = JQuery.ClickEvent
import Trans from './Trans'

type HeaderItemsProps = {
  openNotificationsModal: () => void
  openSupportModal: () => void
  openDealerInformationModal: () => void
  notifications: Array<Notification>
  unreadNotifications: number
  news: string | null
  basename: string
  auctions: Array<Auction>
}

class AppHeaderItems extends React.Component<HeaderItemsProps> {
  
  openAuction = async (notification: Notification) => {
    const id = notification.body.auctionId
    let auction = _.find(this.props.auctions, {Id: id})

    if (!auction && id) {
      const {data} = await window.axios.get<Auction>('/auctions/' + id)
      auction = data
    }

    if (auction && auction.Id) {
      await store.dispatch(hideAuction())
      store.dispatch(showAuction(auction))
    }

    await window.axios.get('/notification/' + notification.id + '/read')
    await updateNotifications()
  }

  endImpersonation = async (event: any) => {
    event.preventDefault()
    await Http.post('/end-impersonation', {state: this, form: new Form({})})

    window.location.href = '/'
  }

  render() {
    const notifications = _.map(_.take(_.filter(this.props.notifications, {read: 0}), 3), notification => {
      notification.body = _.isString(notification.body) ? JSON.parse(notification.body) : notification.body
      return notification
    })

    return (
      <div className='flex flex-col absolute text-left border-0 rounded shadow bg-white mt-1 py-2 right-0 left-auto z-10 fixed'>
        {
          this.props.notifications.length ?
            <div className="flex flex-col">

              {
                _.map(notifications, notification => (
                  <div key={JSON.stringify(notification)}>
                    <a className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200 cursor-pointer text-blue-800 flex flex-col" onClick={() => this.openAuction(notification)}>
                      <span className="text-sm truncate font-semibold">
                        {
                          !notification.read ?
                            <Icon icon="bell" className="text-yellow-500 mr-1"/>
                            :
                            null
                        }

                        <Trans>{_.get(notification, 'body.message')}</Trans>
                      </span>
                      <span className="text-xs truncate">{make(_.get(notification, 'body.make'))} {_.get(notification, 'body.shortDescription')}</span>
                    </a>
                  </div>
                ))
              }

              <a className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200 cursor-pointer text-blue-800 flex flex-col" onClick={this.props.openNotificationsModal}>
                <span className="text-sm truncate font-semibold">
                  <Trans>Alle Benachrichtigungen</Trans>
                </span>
                <span className="text-xs truncate">{this.props.unreadNotifications} <Trans>ungelesen</Trans></span>
              </a>
              <hr className="border-t border-blue-300 w-full h-0 my-2 overflow-hidden"/>
            </div>
            :
            null
        }

        <Link to='/settings' className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200"> <Icon className="text-blue-600" icon="cog"/>
          <span className="text-blue-800 font-semibold px-1"><Trans>Einstellungen</Trans></span>
        </Link>
        {
          !window.app?.user?.authority?.mod_speed_auction_claim ?
            <>
              <hr className="border-t border-blue-300 w-full h-0 my-2 overflow-hidden" />
              <a onClick={this.props.openSupportModal} className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200 cursor-pointer">
                <Icon className="text-blue-600" icon="paper-plane" />
                <span className="text-blue-800 font-semibold px-1"><Trans>Support</Trans></span>
              </a>
            </>

            : null
        }

        {
          this.props.news ?
            <a onClick={this.props.openDealerInformationModal} className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200 cursor-pointer">
              <Icon className="text-blue-600" icon="align-left"/>
              <span className="text-blue-800 font-semibold px-1"><Trans>Händler-Info</Trans></span>
            </a>
            : null
        }

        {
          window.app.user.impersonated_by ?
            <>
              <hr className="border-t border-blue-300 w-full h-0 my-2 overflow-hidden"/>

              <a onClick={(event) => this.endImpersonation(event)} className="block w-full px-6 py-1 whitespace-no-wrap Lohover:bg-blue-200">
                <Icon className="text-blue-600" icon="person-booth"/>
                <span className="text-blue-800 font-semibold px-1">Zu eigenem Account zurückkehren</span>
              </a>
            </>
            : null
        }

        {
          window.app.user && window.app.user.domain === 'ars' && window.app.user.authority && window.app.user.authority.superuser && !window.app.user.impersonated_by ?
            <>
              <hr className="border-t border-blue-300 w-full h-0 my-2 overflow-hidden"/>

              <a href={this.props.basename + '/impersonation'} className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200">
                <Icon className="text-blue-600" icon="person-booth"/>
                <span className="text-blue-800 font-semibold px-1">Impersonation</span>
              </a>
            </>
            : null
        }

        
        {
          !window.app?.user?.authority?.mod_speed_auction_claim ?
            <>
              <hr className="border-t border-blue-300 w-full h-0 my-2 overflow-hidden" />
              <a href={this.props.basename + '/logout'} className="block w-full px-6 py-1 whitespace-no-wrap hover:bg-blue-200">
                <Icon className="text-blue-600" icon="sign-out-alt" />
                <span className="text-blue-800 font-semibold px-1"><Trans>Logout</Trans></span>
              </a>
            </>
            : null
        }
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  notifications: state.app.notifications.notifications,
  unreadNotifications: state.app.unreadNotifications,
  news: state.app.settings.news,
  basename: state.app.basename,
  auctions: state.auctions.auctions
}))(AppHeaderItems)